import { useEffect, useState } from 'react';
import Modal from '@/components/base/Modal';
import { useAppStore } from '@/store/AppStore';
import { REGIONS, SOURCES } from '@/mocks/constants';
import type { Customer } from '@/types';

const inputClass =
  'h-10 w-full rounded-md border border-background-200 bg-white px-3 text-sm text-foreground-800 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100';
const labelClass = 'mb-1.5 block text-xs font-semibold text-foreground-600';

export default function CustomerForm({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { addCustomer } = useAppStore();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [region, setRegion] = useState(REGIONS[0]);
  const [address, setAddress] = useState('');
  const [source, setSource] = useState('Manuel');
  const [error, setError] = useState('');

  function reset() {
    setName('');
    setPhone('');
    setRegion(REGIONS[0]);
    setAddress('');
    setSource('Manuel');
    setError('');
  }

  useEffect(() => {
    if (open) reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      setError('Müşteri adı ve telefon zorunludur.');
      return;
    }
    const customer: Customer = {
      id: `C-${Date.now()}`,
      name: name.trim(),
      phone: phone.trim(),
      region,
      address: address.trim(),
      status: 'Aktif',
      lastService: '',
      totalJobs: 0,
      lastContact: 'Şimdi',
      source,
    };
    addCustomer(customer);
    reset();
    onClose();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Yeni Müşteri"
      maxWidth="max-w-xl"
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-background-200 px-4 py-2 text-sm font-semibold text-foreground-700 hover:bg-background-100"
          >
            Vazgeç
          </button>
          <button
            type="submit"
            form="customer-form"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-600"
          >
            Müşteriyi Kaydet
          </button>
        </>
      }
    >
      <form id="customer-form" onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className={labelClass}>Ad Soyad</label>
            <input
              className={inputClass}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ad Soyad"
            />
          </div>
          <div>
            <label className={labelClass}>Telefon</label>
            <input
              className={inputClass}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="05xx xxx xx xx"
            />
          </div>
          <div>
            <label className={labelClass}>Bölge</label>
            <select className={inputClass} value={region} onChange={(e) => setRegion(e.target.value)}>
              {REGIONS.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className={labelClass}>Kaynak</label>
            <select className={inputClass} value={source} onChange={(e) => setSource(e.target.value)}>
              {SOURCES.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
          <div className="sm:col-span-2">
            <label className={labelClass}>Adres</label>
            <input
              className={inputClass}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Tam adres"
            />
          </div>
        </div>
        {error && (
          <p className="rounded-md bg-red-50 px-3 py-2 text-xs font-semibold text-red-700">{error}</p>
        )}
      </form>
    </Modal>
  );
}